/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit City/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function City({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceBillingCenter/Address/City",
  onChange
  
}) {
let billingCenterContactPostalAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'billing_center',
path: 'contact_postal_address.city',
})
let billingCenterContactPostalAddressCityChangeData = fromData.useDataChange({ viewPath,
context: 'billing_center',
path: 'contact_postal_address.city',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="billing_center.contact_postal_address.city"
 value={billingCenterContactPostalAddressCityValueData}
 onChange={billingCenterContactPostalAddressCityChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="City"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}